import {RESET_GAME_ACTION, MARK_LETTERS_AS_USED_ACTION} from '../constants';

const usedLettersReducer = (state = [], action) => {
    switch (action.type) {
        case RESET_GAME_ACTION:
            return [];
        case MARK_LETTERS_AS_USED_ACTION:
            // Here it is in the opposite in order to preserve the coloring of
            // the last used letter in a case of overlapping words
            return [...action.letterIds, ...state];
        default:
            return state;
    }
};
export default usedLettersReducer;
